var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.235,
    height: 32.264,
    viewBox: "0 0 30.235 32.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2313",
    "data-name": "Rectangle 2313",
    width: 30.235,
    height: 32.264,
    fill: "#101b2d",
    stroke: "#101b2d",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10308",
    "data-name": "Group 10308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10307",
    "data-name": "Group 10307",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28396",
    "data-name": "Path 28396",
    d: "M15.085,0h-.013a.639.639,0,0,0-.213.058L.523,6.189A.616.616,0,0,0,0,6.809V25.415a.717.717,0,0,0,.051.258l.007.007c0,.013.007.02.013.033a.649.649,0,0,0,.316.3l14.349,6.131a.64.64,0,0,0,.362.122.651.651,0,0,0,.407-.122l14.343-6.131a.625.625,0,0,0,.38-.491.06.06,0,0,1,.007-.033V6.809a.62.62,0,0,0-.509-.62L15.389.065,15.376.058a.661.661,0,0,0-.1-.038h-.018c-.013-.007-.026-.007-.04-.013H15.2C15.183.007,15.163,0,15.15,0Zm.033,1.3,3.037,1.3L5.273,8.107c-.013.007-.026.007-.04.013L2.2,6.822ZM19.738,3.27l3.688,1.576L10.3,10.459a.63.63,0,0,0-.375.633v6.713L8.58,15.783a.623.623,0,0,0-.8-.207L6.2,16.365V9.058ZM25,5.524l3.043,1.3L15.118,12.346l-3.037-1.3L24.964,5.537c.013-.007.025-.007.038-.013M1.24,7.765,4.962,9.354v8.011a.622.622,0,0,0,.9.556l1.99-1,2.145,3.218a.623.623,0,0,0,.316.284.273.273,0,0,0,.06.018.5.5,0,0,0,.109.026.309.309,0,0,0,.078.007.237.237,0,0,1,.071-.007c.013-.007.031-.007.051-.013a.286.286,0,0,1,.033-.007c.012-.007.025-.007.031-.013a.421.421,0,0,0,.1-.045.614.614,0,0,0,.316-.62V12.011L14.5,13.438V30.694L1.24,25.022Zm27.754,0V25.022L15.738,30.694V13.431Z",
    transform: "translate(0 -0.001)",
    fill: "#101b2d",
    stroke: "#101b2d",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon4);
export default __webpack_public_path__ + "static/media/social_icon4.c326de01ebc04b855a48cb5d2ddf0f00.svg";
export { ForwardRef as ReactComponent };